
import React, {useState} from "react";
import ReactGA from "react-ga";
import styled from "@emotion/styled";
import MediaQuery from "react-responsive";
import {useTransition, useSpring, animated} from "react-spring";
import { css } from "@emotion/css";
import Menu from "./Menu";
import logo from "../images/logo.png";
import headerBg from "../images/header-bg.jpg";
import { Link } from "react-router-dom";

const HeaderContainer = styled.header`
  width: 100%;
  height: 50px;
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  display: flex;
  padding: 20px 60px;
  justify-content: space-between;
  align-items: center;
  z-index: 6;
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(${headerBg});
    background-size: auto 100%;
    background-position: center;
    z-index: -1;
  }
  @media screen and (max-width: 1024px) {
    padding: 20px;
  }
`;

const Logo = styled.img`
  width: auto;
  height: 20px;
`;

const DesktopMenuContainer = styled.div`
  position: relative;
  /* z-index: 12; */ 
`;
const MenuOpenContainer = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  z-index: 1;
`;
const Hamburger = styled.button`
  position: absolute;
  top: 16px;
  right: 20px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  opacity: 1;
  width: 40px;
  height: 24px;
  z-index: 12;

  &:hover {
    /* opacity: 0.7; */
  }
`;
const MenuOpenContainerOpacity = css`
  width: 100%;
  height: 100%;
  > ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #000;
    > li {
      font-size: 1.5rem;
      margin: 0 0 20px 0;
      @media screen and (max-width: 767px) {
        font-size: 1.25em;
        > a {
          letter-spacing: 2px;
        }
      }
      &:last-child {
        margin: 0 0 0 0;
      }
    }
  }
`;

const HamburgerBox = styled.span`
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative;
`;
const HamburgerInner = styled.span`
  display: block;
  top: 50%;
  margin-top: -2px;

  &,
  &:before,
  &:after {
    width: 40px;
    height: 4px;
    background-color: #FFF;
    border-radius: 4px;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  &:before,
  &:after {
    content: "";
    display: block;
  }
  &:before {
    top: -10px;
  }
  &:after {
    bottom: -10px;
  }

  /* custom */

  top: auto;
  bottom: 0;
  transition-duration: 0.13s;
  transition-delay: 0.13s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);

  &:after {
    top: -20px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      opacity 0.1s linear;
  }
  &:before {
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
      transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  &.is-active {
    transform: translate3d(0, -10px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

    &:after {
      top: 0;
      opacity: 0;
      transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
        opacity 0.1s 0.22s linear;
    }
    &:before {
      top: 0;
      transform: rotate(-90deg);
      transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
        transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
`;

const Header = () => {
  const [isShow, setIsShow] = useState(false);

  const handleMenuOpen = () => {
    isShow ? setIsShow(false) : setIsShow(true);
  };

  const transitions = useTransition(isShow, null, {
    from: { transform: `translateY(-100%)` },
    enter: { transform: `translateY(0%)` },
    leave: { transform: `translateY(-100%)` }
  });

  const MenuList = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    delay: 500
  });
  return (
    <HeaderContainer>
      <Link to="/" onClick={()=>{
        ReactGA.event({
          category: "202012_PRADO",
          action: "Click",
          label: `Menu-logo`,
        });
      }}>
        <Logo src={logo}/>
      </Link>
      {/* pc */}
      <MediaQuery minWidth={1024}>
        <DesktopMenuContainer>
          <Menu />
        </DesktopMenuContainer>
      </MediaQuery>
      {/* mobile */}
      <MediaQuery maxWidth={1023}>
        <div>
          {transitions.map(({ item, props }, keys) => {
            return (
              item && (
                <animated.div
                  className={MenuOpenContainer}
                  style={props}
                  key={keys}
                >
                  <animated.div
                    className={MenuOpenContainerOpacity}
                    style={MenuList}
                  >
                    <Menu handleClose={handleMenuOpen} />
                  </animated.div>
                </animated.div>
              )
            );
          })}
        </div>

        {/* hamburger */}
        <Hamburger onClick={handleMenuOpen}>
          <HamburgerBox>
            <HamburgerInner className={isShow ? "is-active" : ""} />
          </HamburgerBox>
        </Hamburger>
      </MediaQuery>
    </HeaderContainer>
  )
};

export default Header;